import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import { USER_GROUP_MEMBERS_RESOURCE } from '../../constants';
import apiRoutes from '../../../../app/api/routes';

const UserGroupMembersService = ComposedComponent =>
  reduxFetch([
    {
      resource: USER_GROUP_MEMBERS_RESOURCE,
      method: 'get',
      request: (organisationId, userGroupid, t) => ({
        url: apiRoutes.userGroupMembers(organisationId, userGroupid),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getUserGroupMembersFailed'),
          },
        },
      }),
    },
    {
      resource: `${USER_GROUP_MEMBERS_RESOURCE}Page`,
      method: 'get',
      request: (organisationId, userGroupId, page) => ({
        url: addParametersToUri(apiRoutes.userGroupMembers(organisationId, userGroupId), { page }),
        meta: {
          mergeWithOtherList: {
            resource: USER_GROUP_MEMBERS_RESOURCE,
            idProp: 'id',
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UserGroupMembersService;
